module.exports = __webpack_public_path__ + "img/Immigration.fd421d30.jpg";